import React from "react";

const AllProjects = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="8" height="8" fill="inherit" />
      <rect y="10" width="8" height="8" fill="inherit" />
      <rect x="10" width="8" height="8" fill="inherit" />
      <rect x="10" y="10" width="8" height="8" fill="inherit" />
    </svg>
  );
};

export default AllProjects;
